import React from 'react';
import {Dispatch} from "redux";
import TextField from "../layout/TextField";
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {BrandA, BrandLink} from "./buttons/buttons";
import {TransactionService} from "../transactions/TransactionService";
import {getContainer} from "../ioc/IOCSetup";
import {hasFiatExchangeAmount, toFiatAmount} from "../currency/currency-utils";
import {t} from "../i18n";
import {
    getCurrencyDefinitionByCode,
    getCurrencyDefinitions,
    getPreferredFiatExchange
} from "../selectors/settings-selectors";
import {AccountBalance, Currency, CurrencyDefinition, TransferLimit, UserBonusView} from "../http/protocol";
import Title from "../layout/Title";
import VerifyIcon from "../utils/verifyIcon";
import ClockIcon from "../utils/clockIcon";
import {showCashier} from '../payments/DepositActions';
import {getActiveBalance} from "../selectors/payments-selectors";
import CurrencyFormatter from "../utils/CurrencyFormatter";
import {Big} from "big.js";

interface PropsFromDispatch {
    hide: () => void;
}

type AllProps = PropsFromDispatch & Props;

interface State {
    toUserUid:string;
    amount:string;
    currencyName?:string;
    phase:number;
    errorNoValue:boolean;
    amountValid:boolean;
    validId:boolean;
    transferError:boolean;
    errorText:string;
    errorTextUser:string;
}

interface Props {
    onClick: ()=>void;
    activeCurrency?:string;
    activeCurrencyDef? : CurrencyDefinition;
    currencyDefinitions? : CurrencyDefinition[];
    preferredExchangeCurrency? : string;
    context? : TransferLimit[];
    currencies? : Currency[];
    activeBonuses? : UserBonusView[];
    balance? : AccountBalance;
}

export class TipPlayer extends React.Component<AllProps, State>{
    service:TransactionService;

    constructor(props:AllProps) {
        super(props);
        this.service = getContainer().getTransactionService();

        let currencyName:string = "";


        props.currencies && props.currencies.filter((curr) => {
            console.log(curr.code)
            if(curr.code === props.activeCurrency) {
                currencyName = curr.name || "";
            }
        })

        this.state = {toUserUid:"", amount:"", currencyName: currencyName, phase:0, errorNoValue:false, errorText:"", amountValid:false, validId:false, transferError:false, errorTextUser:""}
    }

    componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<State>, snapshot?: any) {
        if(this.state.amount != prevState.amount) {
            this.amountValid();
        }
        if(this.state.toUserUid != prevState.toUserUid) {
            this.userValid();
        }
    }

    sendTip() {
        this.service.transferToPlayer({toUserUid: this.state.toUserUid, amount:Number(this.state.amount), currency:this.props.activeCurrency})
            .then((res)=>{
                this.setState({phase:1})
        }).catch((e)=> {
            this.setState({transferError:true, phase:1})
        })
    }

    changeUserID(e:any) {
        e.preventDefault();
        this.setState({toUserUid:e.target.value})
    }

    updateAmount(e:any) {
        e.preventDefault();
        this.setState({amount:e.target.value})
    }

    userValid() {
        const toUserUid = this.state.toUserUid

        if (toUserUid == undefined  ||  toUserUid.length < 3  ||  toUserUid.length > 10) {
            this.setState({errorTextUser:t("tip.invalidUserId"), validId:false})
        } else {
            this.setState({validId: true, errorTextUser:""})
        }
    }

    amountValid()  {
        let context = this.props.context;

        if(isNaN(Number(this.state.amount))) {
            this.setState({errorText:t("store.bundles.noZeroAmount"), amountValid:false})
        } else if(context) {
            let tl = context?.filter((tl) => {
                return tl.currency === this.props.activeCurrency;
            })
            if(tl[0] && tl[0].minTipAmount && tl[0].minTipAmount > Number(this.state.amount)) {
                this.setState({errorText:t("tip.min-amount", { amount : CurrencyFormatter.formatWithSymbol(this.props.activeCurrencyDef, new Big(tl[0].minTipAmount))}), amountValid:false})
            } else {
                this.setState({errorText:"", amountValid:true})
            }
            if(Number(this.state.amount) === 0 || this.state.amount.length === 0) {
                this.setState({errorText:t("store.bundles.noZeroAmount"), amountValid:false});
            }
            if(Number(this.state.amount) > (this.props.balance?.balance?.amount ?? 0)) {
                this.setState({errorText:t("payments.tip-exceed-balance"), amountValid:false});
            }
        }
    };

    isValidForm() {
        return this.state.toUserUid  &&  this.state.toUserUid.length > 0 && this.state.amount.length > 0 && this.state.amountValid && this.state.validId;
    }
    getBigAmount() {
        try {
            return new Big(this.state.amount);
        } catch (e){
            return new Big(0);
        }
    }

    render() {
        if ((this.props.activeBonuses?.length ?? 1) > 0) {
            return (
                <div className="cashier-inner-container withdraw content-wrapper">
                    <div className={"alert alert-danger"}>
                        <p>
                            {t(`tip.activeBonus`)}
                        </p>
                    </div>
                    <BrandLink to={"/account/bonus"} onClick={()=>this.props.hide()} className={"btn btn-primary full-width"}>{t("withdraw.go-to-bonuses")}</BrandLink>
                </div>
            )
        }



        if(this.state.phase === 0) {
            return(
                <div className="cashier-inner-container withdraw content-wrapper">

                    <div className="choose-address-container">
                    <div className="withdraw-title">
                        <Title animate={true} title={t("tip.recipientHeader")} />
                        <div className="help-text-wrapper">
                            <span className="help-text">{t("tip.recipientSubHeader")}</span>
                        </div>
                    </div>

                    <TextField type="text"
                               errorText={this.state.errorTextUser}
                               placeholder={t("tip.recipientInputField")}
                               value={this.state.toUserUid}
                               onChange={(e)=>this.changeUserID(e)}
                    />
                    </div>
                    <div className="choose-address-container">
                    <div className="withdraw-title">
                        <Title animate={true} title={t("tip.amountHeader")}/>
                    </div>
                    <TextField type="text"
                               errorText={this.state.errorText}
                               placeholder={this.state.currencyName}
                               value={this.state.amount}
                               onChange={(e)=>this.updateAmount(e)}
                    />
                    {this.state.amount.length > 0 && !isNaN(Number(this.state.amount)) && this.props.activeCurrency && this.state.amountValid && this.state.errorText.length === 0 && hasFiatExchangeAmount(this.props.activeCurrency, this.props.preferredExchangeCurrency, this.props.currencyDefinitions) && (
                        <div className={""}>
                            <div className={"col-12 exchange-amount"}>
                                {t("cashier.approximately")} {toFiatAmount(this.props.activeCurrency, parseFloat(this.state.amount), this.props.preferredExchangeCurrency, this.props.currencyDefinitions)}
                            </div>
                        </div>)
                    }
                    </div>

                    <div className={"row button-wrapper"}>
                        <div className={"col-12 button"}>
                            {this.props.currencyDefinitions && <BrandA  className={"btn btn-cta full-width large"} disabled={!this.isValidForm()} onClick={()=>this.sendTip()} >{t("tip.sendButton", { amount: this.state.amountValid ? CurrencyFormatter.formatWithSymbol(this.props.activeCurrencyDef, this.getBigAmount()) : ""})}</BrandA>}
                        </div>
                    </div>
                </div>
            )
        } else if(this.state.phase === 1) {
            return (
                <div className={"withdraw-response-container"}>
                    <React.Fragment>
                        <div className={!this.state.transferError ? "summaryContainer ok" : `summaryContainer rejected`}>
                            {
                                !this.state.transferError
                                    ? <VerifyIcon className={`check-icon`} animate={true} />
                                    : <ClockIcon className={`clock-icon`} animate={true} />
                            }
                            {
                                <div className={"withdraw-title"}>
                                    {!this.state.transferError
                                        ?
                                        t("tip.confirmationTitle", {user: this.state.toUserUid})
                                        :
                                        t("tip.transferErrorTitle",)
                                    }
                                </div>
                            }
                        </div>
                        <div className={"withdraw-response-inner-container"}>
                            <div className={"withdraw-summary"}>
                                <div className={"payout"}>
                                    <div className={"amountContainer"}>
                                        <span className={"methodName"}>{`${t("payments.account")}`}</span>
                                        <span className={"email"}>{this.state.toUserUid}</span>
                                    </div>
                                    <div className={"amountContainer"}>
                                        <span className={"amountLabel"}>{"Amount"}</span>
                                        <span className={"amount"}>{this.state.amount + " " + this.state.currencyName}</span>
                                    </div>
                                </div>
                            </div>
                            <BrandA className={"btn btn-cta full-width large"} onClick={() => this.props.onClick()}>OK</BrandA>

                        </div>
                    </React.Fragment>
                </div>
            )
        } else {
            return (<div/>)
        }
    }}

const mapStateToProps = (app:AppState) => (
    {
        activeCurrency:app.user.activeCurrency,
        preferredExchangeCurrency : getPreferredFiatExchange(app),
        currencyDefinitions : getCurrencyDefinitions(app),
        context  : app.settings.settings?.transferLimits,
        currencies: app.user.user && app.user.user.currencies,
        activeBonuses: app.bonus.activeBonuses,
        balance : getActiveBalance(app),
        activeCurrencyDef : app.user.user?.currencies?.find(c => c.code === app.user.activeCurrency)
    }
)

const mapDispatchToProps = (dispatch : Dispatch) : PropsFromDispatch => (
    {
        hide : () => dispatch(showCashier(false)),
    }
);

export default connect(mapStateToProps, mapDispatchToProps)(TipPlayer);